import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  tableContainer: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    width: 'fit-content',
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: theme.shadows[1],
  },
  legendItemContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  legendColorBox: {
    ...stylesConstants.legendColorBox,
    margin: theme.spacing(1),
    borderRadius: theme.spacing(0.25),
  },
}));
